import type { CharacterGridSpec } from "@/character/grid";
import type { PetDefinition } from "@/pet/types";

export type PetGameArt = {
  petSpritesheetUrl: string;
  petSpritesheetGrid: CharacterGridSpec;
  petIdleTextureUrl: string;
};

export function petToGameArt(pet: PetDefinition | null | undefined): PetGameArt | undefined {
  if (!pet?.spritesheetDataUrl) return undefined;
  return {
    petSpritesheetUrl: pet.spritesheetDataUrl,
    petSpritesheetGrid: pet.grid,
    petIdleTextureUrl: pet.actions.idle,
  };
}
